/**
 * Scholarships module for FDT portal (client-src/js/scholarships.js)
 */

document.addEventListener('DOMContentLoaded', function () {
    initScholarshipQuickView();
    initCopyScholarshipLink();
});

/**
 * Initializes the Quick View Modal functionality on Scholarships Index
 */
export function initScholarshipQuickView() {
    const modalEl = document.getElementById('scholarshipQuickViewModal');
    if (!modalEl) return;

    let quickViewModal = null;
    if (window.bootstrap && bootstrap.Modal) {
        quickViewModal = new bootstrap.Modal(modalEl);
    }

    document.querySelectorAll('.btn-quick-view').forEach(btn => {
        btn.addEventListener('click', function () {
            const id = this.getAttribute('data-scholarship-id');
            if (!id) return;

            // Open modal in loading state
            const titleEl = document.getElementById('modalScholarshipTitle');
            const contentEl = document.getElementById('modalContentBody');
            if (titleEl) titleEl.textContent = 'Đang tải thông tin...';
            if (contentEl) {
                contentEl.innerHTML = '<div class="text-center py-4 text-muted"><div class="spinner-border text-primary spinner-border-sm me-2" role="status"></div> Đang tải thông tin chi tiết học bổng...</div>';
            }

            if (quickViewModal) {
                quickViewModal.show();
            } else if (window.jQuery) {
                $('#scholarshipQuickViewModal').modal('show');
            }

            // Fetch JSON details
            fetch(`/Scholarships/QuickViewJson?id=${id}`)
                .then(res => res.json())
                .then(data => {
                    if (data.success) {
                        if (titleEl) titleEl.textContent = data.title;
                        const orgEl = document.getElementById('modalOrganizationText');
                        if (orgEl) orgEl.innerHTML = `<i class="fa fa-building-o"></i> ${data.organization}`;
                        
                        const catEl = document.getElementById('modalCategoryBadge');
                        if (catEl) catEl.textContent = data.category;

                        const statusEl = document.getElementById('modalStatusBadge');
                        if (statusEl) statusEl.textContent = data.statusText;

                        const valEl = document.getElementById('modalScholarshipValue');
                        if (valEl) valEl.textContent = data.scholarshipValue;

                        const qtyEl = document.getElementById('modalQuantity');
                        if (qtyEl) qtyEl.textContent = data.quantity ? `${data.quantity} suất` : 'Không giới hạn';

                        const deadlineEl = document.getElementById('modalDeadline');
                        if (deadlineEl) deadlineEl.textContent = data.applicationDeadline || 'Không giới hạn';

                        const targetEl = document.getElementById('modalTargetStudents');
                        if (targetEl) targetEl.textContent = data.targetStudents;

                        const contactEl = document.getElementById('modalContactInfo');
                        if (contactEl) contactEl.textContent = data.contactInfo || 'Phòng Công tác Sinh viên (Phòng A1-102)';

                        if (contentEl) contentEl.innerHTML = data.content || '<p class="text-muted">Không có nội dung chi tiết.</p>';

                        const detailsLink = document.getElementById('modalDetailsPageLink');
                        if (detailsLink) detailsLink.setAttribute('href', data.detailsUrl);

                        const applyBtn = document.getElementById('modalApplyButton');
                        if (applyBtn) {
                            if (data.applicationUrl) {
                                applyBtn.setAttribute('href', data.applicationUrl);
                                applyBtn.classList.remove('d-none');
                            } else {
                                applyBtn.setAttribute('href', data.detailsUrl);
                                applyBtn.classList.remove('d-none');
                            }
                        }
                    } else {
                        if (contentEl) contentEl.innerHTML = `<div class="alert alert-danger">${data.message || 'Không thể tải thông tin học bổng.'}</div>`;
                    }
                })
                .catch(err => {
                    console.error('Scholarship QuickView Error:', err);
                    if (contentEl) contentEl.innerHTML = '<div class="alert alert-danger">Đã có lỗi xảy ra khi kết nối máy chủ. Vui lòng thử lại.</div>';
                });
        });
    });
}

/**
 * Initializes copy link buttons
 */
export function initCopyScholarshipLink() {
    const copyBtns = document.querySelectorAll('[data-action="copy-scholarship-link"], #btnCopyScholarshipLink');
    copyBtns.forEach(btn => {
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            copyScholarshipLink();
        });
    });
}

/**
 * Copies current URL to clipboard
 */
export function copyScholarshipLink() {
    navigator.clipboard.writeText(window.location.href)
        .then(function () {
            alert('Đã sao chép liên kết bài viết học bổng vào clipboard!');
        })
        .catch(function () {
            const input = document.createElement('input');
            input.value = window.location.href;
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
            alert('Đã sao chép liên kết bài viết học bổng vào clipboard!');
        });
}

// Global exposure for fallback/compatibility
if (typeof window !== 'undefined') {
    window.copyScholarshipLink = copyScholarshipLink;
    window.copyLink = copyScholarshipLink;
    window.initScholarshipQuickView = initScholarshipQuickView;
}
